import { Preferences } from "../../profile/objects/preferences";
import { COMMERCIAL_TRIP_MODULE } from "../constant/commercialConstant";
import { Column } from "../objects/column";
import { setListPreference, ListPreferenceResult } from "../../utils/list/utils/setListPreference";

// state_columns already reflects the correct domain variant (see EMPTY_TRIP_LIST_CONFIGURATION in tripConstants.ts)
// so we pass it as default_columns to preserve domain-specific column definitions.
export const setCommercialTripListPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: COMMERCIAL_TRIP_MODULE,
        default_columns: state_columns,
        default_order_by: '',
        default_order: 'asc',
    });